import { ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { ChartDisplaySettingsModel } from '../../../Charts/models/chart-display-settings.model';
import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import { ChartDisplaySettingsFieldModel } from '../../models/chart-display-settings-field.model';
import { ChartHeaderElementsEnum } from '../../../Charts/models/chart-display-settings.model';
import { ChartDisplayElementModel } from '../../../../Common/Reports/models/chart-display-element.model';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { ChartStylesModel } from '../../../../Common/Charts/models/chart-styles.model';
import { ChartBlockComponent } from '../ChartBlock/chart-block.component';
import { TopEntitiesChartBlockComponent } from '../../../../Monitor/Shared/components/TopEntitiesChartBlock/top-entities-chart-block.component';
import { DateQueryTypeEnum } from '@api/mentions/enum/date-query-type.enum';
import { EntityType } from '@api/targeting/enum/entity.type.enum';
import { Am5ChartBlockComponent } from '../Am5ChartBlock/am5-chart-block.component';

@Component({
    selector: 'agpr-chart-header-display-settings-field',
    templateUrl: './chart-display-settings-field.component.html',
    styleUrls: ['./chart-display-settings-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => ChartDisplaySettingsFieldComponent)
        }
    ],
    standalone: false
})
export class ChartDisplaySettingsFieldComponent extends AbstractFormFieldComponent implements OnInit, OnChanges {

    @Input() declare value: ChartDisplaySettingsModel;
    @Input() declare field: ChartDisplaySettingsFieldModel;

    title: boolean = true;
    date: boolean = true;
    displayDate: boolean;
    source: boolean = true;
    displaySourceAsLink: boolean = true;

    displaySource: boolean;
    // @TODO: probably don't default here
    previousPeriod: boolean = false;
    disablePreviousPeriod: boolean = false;
    trendIndicators: boolean = false;
    entityProfile: boolean = false;
    displayPreviousPeriod: boolean = false;
    displayTrendIndicators: boolean = false;
    displayEntityProfile: any;

    constructor(
        private pageBuilderService: AbstractPageBuilderService,
        private changeDetector: ChangeDetectorRef
    ) {

        super();
    }

    ngOnInit(): void {
        this.displayDate = this.field.headerElements?.includes(ChartHeaderElementsEnum.DATE);
        this.displaySource = this.field.headerElements?.includes(ChartHeaderElementsEnum.SOURCE) && !this.value?.multiSource;
        this.displayPreviousPeriod = this.field.displayPreviousPeriod;
        this.displayTrendIndicators = this.field.displayTrendIndicators;
        const displayChartEntityProfile = this.pageBuilderService.getDisplayChartEntityProfile();
        this.displayEntityProfile = displayChartEntityProfile ? this.field.displayEntityProfile : null;
        this.title = this.value?.title;
        this.date = this.value?.dateRange;
        this.source = this.value?.sourceLink;
        this.previousPeriod = this.value?.previousPeriod;
        this.trendIndicators = this.value?.trendIndicators;
        this.entityProfile = this.value?.entityProfile;
        this.displaySourceAsLink = this.pageBuilderService.getDisplaySourceAsLink();
        this.checkComponentChange();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.field.headerElements?.includes(ChartHeaderElementsEnum.SOURCE)) {
            this.displaySource = !changes.value.currentValue.multiSource;
        }
        if (this.field.displayTrendIndicatorsAppearCondition) {
            this.displayTrendIndicators = this.field.displayTrendIndicatorsAppearCondition(this.block.displayElement as ChartDisplayElementModel);
        }

        const displayElement = this.block?.displayElement as ChartDisplayElementModel;
        // disable previous period checkbox if date range is all
        if (displayElement?._series?.length
            && displayElement._series[0].dateRange.type === DateQueryTypeEnum.ALL
        ) {
            this.disablePreviousPeriod = true;
            this.previousPeriod = false;
            this.value.previousPeriod = false;
            if (displayElement?.styles?.chartDisplaySettings) {
                displayElement.styles.chartDisplaySettings.previousPeriod = false;
            }
            displayElement._series.forEach(item => item.hasPreviousPeriod = false);
        } else {
            this.disablePreviousPeriod = false;
        }
    }

    updateValue() {
        this.value.title = this.title;
        if (this.displayDate) {
            this.value.dateRange = this.date;
        }
        if (this.displaySource) {
            this.value.sourceLink = this.source;
        }
        this.value.previousPeriod = this.previousPeriod;
        if (this.value.previousPeriod === false) {
            this.value.trendIndicators = false;
        } else {
            this.value.trendIndicators = this.trendIndicators;
        }
        this.value.entityProfile = this.entityProfile;
        this.value.displaySourceAsLink = this.displaySourceAsLink;
        const series = (this.block.displayElement as ChartDisplayElementModel).series;
        if (series?.length > 0) {
            series.forEach(s => {
                if (!s.styles) {
                    s.styles = new ChartStylesModel();
                }
                s.styles.displayEntityProfile = this.displayEntityProfile;
                s.styles.entityProfile = this.entityProfile;
            });
        }
        this.value = new ChartDisplaySettingsModel(this.value);
        this.block.displayElement.styles.chartHeaderSettings = this.value;
        this.checkComponentChange();
        this.changes.emit(this.value);
        this.changeDetector.detectChanges();
    }

    private checkComponentChange(): void {
        if (this.field.displayEntityProfile) {
            if (this.value.entityProfile) {
                this.block.type.componentType = TopEntitiesChartBlockComponent;
            } else {
                this.block.type.componentType = this.field.displayEntityProfile === EntityType.CONTACT ||
                this.field.displayEntityProfile === EntityType.OUTLET ?
                    Am5ChartBlockComponent : ChartBlockComponent;
            }
            this.block.componentChange$.next(true);
        }
    }
}

